import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import { BaseModel } from "model/BaseModel";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import UnidadeOrganizacionalService from "service/indicadores/UnidadeOrganizacionalService";
import { cepMask, phoneMask } from "utils/mask";

const unidadeOrganizacionalService = new UnidadeOrganizacionalService();

export default function UnidadeOrganizacionalCadastro() {

    const [unidadeOrganizacional, setUnidadeOrganizacional] = useState<UnidadeOrganizacional>(new UnidadeOrganizacional());
    const [titulo, setTitulo] = useState<string>('Unidade Organizacional');

    const { register, control, handleSubmit, setFocus, clearErrors, setError, formState: { errors } } = useForm();

    function alterar(changes: Partial<UnidadeOrganizacional>) {
        setUnidadeOrganizacional({ ...unidadeOrganizacional, ...changes });
    }

    function validar() {
        if (!unidadeOrganizacional.codigoInterno) {
            setError("codigoInterno", { type: "manual", message: "Código é obrigatório." }, { shouldFocus: true });
            return false;
        }
        if (!unidadeOrganizacional.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório." }, { shouldFocus: true });
            return false;
        }
        const { regimeApuracaoIrpj, regimePisCofins, vigenciaTributaria } = unidadeOrganizacional;
        if ((regimeApuracaoIrpj || regimePisCofins || vigenciaTributaria)
            && (!regimeApuracaoIrpj || !regimePisCofins || !vigenciaTributaria)) {
            setError('tributacao', { type: 'manual', message: 'Informe IRPJ, PIS/COFINS e início da vigência conjuntamente.' });
            return false;
        }
        clearErrors('tributacao');
        return true;
    }

    return (
        <BaseCadastro model={unidadeOrganizacional} service={unidadeOrganizacionalService} setModel={(value: UnidadeOrganizacional) => setUnidadeOrganizacional(value)} validar={() => validar()} pathCadastro={"/unidadeOrganizacional"} urlService={"/unidadeOrganizacional"} tituloPagina={titulo}>
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
            </div>
            <TabView renderActiveOnly={false}>
                <TabPanel header="Dados gerais">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <Checkbox inputId="unidade-ativa" checked={!!unidadeOrganizacional.ativa}
                                onChange={(e) => alterar({ ativa: !!e.checked })} />
                            <label htmlFor="unidade-ativa" style={{ marginLeft: 8 }}>Ativa</label>
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col-sm-12" obrigatorio>Código</Label>
                        <div className="col-sm-12">
                            <Controller name="codigoInterno" control={control} render={({ field }) => (
                                <InputNumber required
                                    inputRef={field.ref}
                                    className={errors.codigoInterno ? "p-invalid" : ""}
                                    value={unidadeOrganizacional.codigoInterno}
                                    onChange={(e) => setUnidadeOrganizacional({ ...unidadeOrganizacional, codigoInterno: e.value as number })}
                                    style={{ width: '30%' }}
                                    locale="pt-BR"
                                    useGrouping={false}
                                    maxFractionDigits={0}
                                />
                            )} />
                        </div>
                        {errors.codigoInterno && errors.codigoInterno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoInterno?.message as string}</span> : null}
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Nome</Label>
                        <div className="col-sm-12">
                            <InputText className={errors.nome ? "p-invalid" : ""} value={unidadeOrganizacional.nome} style={{ width: '100%' }} {...register("nome", {
                                onChange: (e) => {
                                    clearErrors("nome")
                                    setUnidadeOrganizacional({ ...unidadeOrganizacional, nome: e.target.value })
                                }
                            })} />
                        </div>
                        {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
                    </div>


                </TabPanel>
                <TabPanel header="Dados fiscais">
                    {errors.tributacao && <p role="alert" style={{color: 'red'}}>{errors.tributacao.message as string}</p>}
                    <div className="row">
                        <div className="col-12 mb-3">
                            <Checkbox inputId="unidade-estabelecimento-fiscal" checked={!!unidadeOrganizacional.estabelecimentoFiscal}
                                onChange={(e) => alterar({ estabelecimentoFiscal: !!e.checked })} />
                            <label htmlFor="unidade-estabelecimento-fiscal" style={{ marginLeft: 8 }}>Estabelecimento fiscal</label>
                        </div>
                        <div className="col-12 mb-3">
                            <Checkbox inputId="unidade-emite-nfe" checked={!!unidadeOrganizacional.emiteNfe}
                                onChange={(e) => alterar({ emiteNfe: !!e.checked })} />
                            <label htmlFor="unidade-emite-nfe" style={{ marginLeft: 8 }}>Emite NF-e</label>
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Razão social</Label>
                            <InputText value={unidadeOrganizacional.razaoSocial ?? ""} maxLength={60}
                                onChange={(e) => alterar({ razaoSocial: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Nome fantasia</Label>
                            <InputText value={unidadeOrganizacional.nomeFantasia ?? ""} maxLength={60}
                                onChange={(e) => alterar({ nomeFantasia: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>CNPJ</Label>
                            <InputText value={unidadeOrganizacional.cnpj ?? ""} maxLength={18}
                                onChange={(e) => alterar({ cnpj: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 14) || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Inscrição estadual</Label>
                            <InputText value={unidadeOrganizacional.inscricaoEstadual ?? ""} maxLength={20}
                                onChange={(e) => alterar({ inscricaoEstadual: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Inscrição municipal</Label>
                            <InputText value={unidadeOrganizacional.inscricaoMunicipal ?? ""} maxLength={20}
                                onChange={(e) => alterar({ inscricaoMunicipal: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Regime tributário (CRT)</Label>
                            <Dropdown value={unidadeOrganizacional.regimeTributario} options={unidadeOrganizacionalService.getListaRegimeTributario()}
                                optionLabel="label" optionValue="value" showClear
                                onChange={(e) => alterar({ regimeTributario: e.value ?? null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Apuração do IRPJ</Label>
                            <Dropdown value={unidadeOrganizacional.regimeApuracaoIrpj} showClear
                                options={[{label: 'Lucro real', value: 'LUCRO_REAL'}, {label: 'Lucro presumido', value: 'LUCRO_PRESUMIDO'}]}
                                onChange={e => alterar({regimeApuracaoIrpj: e.value})} style={{width: '100%'}} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Enquadramento padrão de PIS/COFINS</Label>
                            <Dropdown value={unidadeOrganizacional.regimePisCofins} showClear
                                options={[{label: 'Cumulativo', value: 'CUMULATIVO'}, {label: 'Não cumulativo', value: 'NAO_CUMULATIVO'}, {label: 'Misto', value: 'MISTO'}]}
                                onChange={e => alterar({regimePisCofins: e.value})} style={{width: '100%'}} />
                            <small>Confirme o enquadramento com a contabilidade. Produtos e operações podem ter tratamentos específicos.</small>
                        </div>
                        <div className="col-12 mb-3">
                            <Label className="d-block" htmlFor="vigenciaTributaria">Início da vigência tributária</Label>
                            <InputText id="vigenciaTributaria" type="date" value={unidadeOrganizacional.vigenciaTributaria ?? ''}
                                onChange={e => alterar({vigenciaTributaria: e.target.value || null})} style={{ width: '100%' }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>E-mail fiscal</Label>
                            <InputText type="email" value={unidadeOrganizacional.emailFiscal ?? ""} maxLength={254}
                                onChange={(e) => alterar({ emailFiscal: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Telefone</Label>
                            <InputText value={phoneMask(unidadeOrganizacional.telefone ?? "")} maxLength={15}
                                onChange={(e) => alterar({ telefone: e.target.value.replace(/\D/g, "").slice(0, 11) || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Logradouro</Label>
                            <InputText value={unidadeOrganizacional.logradouro ?? ""} maxLength={60}
                                onChange={(e) => alterar({ logradouro: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Número</Label>
                            <InputText value={unidadeOrganizacional.numeroEndereco ?? ""} maxLength={60}
                                onChange={(e) => alterar({ numeroEndereco: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Complemento</Label>
                            <InputText value={unidadeOrganizacional.complemento ?? ""} maxLength={60}
                                onChange={(e) => alterar({ complemento: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Bairro</Label>
                            <InputText value={unidadeOrganizacional.bairro ?? ""} maxLength={60}
                                onChange={(e) => alterar({ bairro: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Município</Label>
                            <InputText value={unidadeOrganizacional.municipio ?? ""} maxLength={60}
                                onChange={(e) => alterar({ municipio: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Código IBGE do município</Label>
                            <InputText value={unidadeOrganizacional.codigoMunicipioIbge ?? ""} maxLength={7}
                                onChange={(e) => alterar({ codigoMunicipioIbge: e.target.value.replace(/\D/g, "") || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>UF</Label>
                            <InputText value={unidadeOrganizacional.uf ?? ""} maxLength={2}
                                onChange={(e) => alterar({ uf: e.target.value.toUpperCase() || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>CEP</Label>
                            <InputText value={cepMask(unidadeOrganizacional.cep ?? "")} maxLength={9}
                                onChange={(e) => alterar({ cep: e.target.value.replace(/\D/g, "").slice(0, 8) || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>Código BACEN do país</Label>
                            <InputText value={unidadeOrganizacional.codigoPaisBacen ?? ""} maxLength={4}
                                onChange={(e) => alterar({ codigoPaisBacen: e.target.value.replace(/\D/g, "") || null })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-3">
                            <Label>País</Label>
                            <InputText value={unidadeOrganizacional.pais ?? ""} maxLength={60}
                                onChange={(e) => alterar({ pais: e.target.value || null })} style={{ width: "100%" }} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Parâmetros para emissão direta">
                    <div className="row">
                        <Label className="col-sm-12" htmlFor="aliquotaPisPadrao">Percentual da alíquota padrão de PIS (%)</Label>
                        <div className="col-sm-12 mb-3">
                            <InputNumber inputId="aliquotaPisPadrao" value={unidadeOrganizacional.aliquotaPisPadrao ?? null}
                                min={0} max={100} maxFractionDigits={6} locale="pt-BR"
                                onValueChange={e => alterar({ aliquotaPisPadrao: e.value ?? null })}
                                style={{ width: '100%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col-sm-12" htmlFor="aliquotaCofinsPadrao">Percentual da alíquota padrão de COFINS (%)</Label>
                        <div className="col-sm-12 mb-3">
                            <InputNumber inputId="aliquotaCofinsPadrao" value={unidadeOrganizacional.aliquotaCofinsPadrao ?? null}
                                min={0} max={100} maxFractionDigits={6} locale="pt-BR"
                                onValueChange={e => alterar({ aliquotaCofinsPadrao: e.value ?? null })}
                                style={{ width: '100%' }} />
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </BaseCadastro>
    )
}
